import { Component, inject, OnInit, signal } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ProgressBarModule } from 'primeng/progressbar';
import { Core } from '../_core/core';
import { Settings } from '../_core/settings';
import { BillingService } from '../_core/billings';
import { Notification } from '../_core/notification';
import { Metering } from '../_core/metering';
import { HomeS } from '../_core/home';
import { BrandingService } from '../_core/branding.service';
import { AuthService } from '../_core/auth.service';
import { IHome } from '../core.interface';

@Component({
  selector: 'app-loading',
  standalone: true,
  imports: [CommonModule, ProgressBarModule],
  templateUrl: './loading.html',
  styleUrls: ['./loading.scss'],
})
export class Loading implements OnInit {
  private router = inject(Router);
  private $core = inject(Core);
  private $settings = inject(Settings);
  private $billings = inject(BillingService);
  private $notification = inject(Notification);
  private $metering = inject(Metering);
  private $home = inject(HomeS);
  private $branding = inject(BrandingService);
  private $auth = inject(AuthService);

  public logoUrl = this.$branding.logoUrl;

  public loadingText = signal<string>('Iniciando sesión...');
  public progress = signal<number>(5);

  ngOnInit() {
    this.initSequence();
  }

  private async initSequence() {
    await this.$auth.isUserDataLoaded();
    if (this.$auth.hasExpiredPassword()) {
      await this.router.navigate(['/', 'change-password'], { replaceUrl: true });
      return;
    }

    let tenantSelected = this.$core.selectedBuilding();
    if (!tenantSelected) {
      tenantSelected = await this.$core.getTenantFromLocal();
    }

    this.clearTenantCaches();

    try {
      this.updateStatus('Cargando panel...', 50);
      const home = await this.$home.fetchHomeData(true);
      this.updateStatus('Listo', 100);

      const tenantId = tenantSelected!.tenantId;
      this.startBackgroundLoads(tenantId, home);

      await this.router.navigate(['/home']);
    } catch (error) {
      console.error('Error durante la carga:', error);
      this.router.navigate(['/', 'propiedades']);
    }
  }

  private startBackgroundLoads(tenantId: string, home: IHome | null): void {
    void this.$settings.fetchTenantMe(tenantId);
    void this.$notification.fetchNotifications('', true);
    void this.$settings.fetchContact();

    if (home?.hasBilling === true) {
      void this.$billings.prefetchHomeSettlements(tenantId);
    }
  }

  /** Invalida caché de servicios con estado por tenant antes de precargar. */
  private clearTenantCaches(): void {
    this.$metering.clear();
    this.$home.clear();
    this.$billings.clear();
    this.$settings.clear();
    this.$notification.clearNotifications();
  }

  private updateStatus(text: string, value: number) {
    this.loadingText.set(text);
    this.progress.set(value);
  }
}
